function t(t,[n,a]){return Math.min(a,Math.max(n,t))}export{t as clamp};
//# sourceMappingURL=index.js.map
